import React, { useState } from "react";
import "./bootstrap.min.css";
import "./AppBody.css";
import { Avatar } from "@material-ui/core";
import { useStateValue } from "./StateProvider";
import db from "./firebase";
import firebase from "firebase";

function AppBody() {
  const [{ user }, dispatch] = useStateValue();
  const [input, setInput] = useState("");
  const [des, setDes] = useState("");
  const [img, setImg] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();

    db.collection("posts").add({
      title: input,
      message: des,
      timestamp: firebase.firestore.FieldValue.serverTimestamp(),
      profilePic: user.photoURL,
      username: user.displayName,
      image: img
    });
    setInput("");
    setDes("");
    setImg("");
  };
  return (
    <div className="appbody">
      <div className="container card darrr appp">
        <div className="row">
          <div className="col center tit">
            <h1>{`Add A Post,  ${user.displayName}`}</h1>
          </div>
        </div>
        <form>
          <div className="row">
            <div className="col-sm-1 ava">
              <Avatar src={user.photoURL} className="circle" />
            </div>
            <div className="col-sm-4">
              <div class="form-group">
                <label for="title">TITLE</label>
                <input
                  required
                  value={input}
                  onChange={(e) => setInput(e.target.value)}
                  name="title"
                  type="title"
                  id="title"
                  className="form-control"
                />
              </div>
            </div>
            <div className="col-sm-5">
              <div class="form-group">
                <label for="description">DESCRIPTION</label>
                <textarea
                  required
                  value={des}
                  onChange={(e) => setDes(e.target.value)}
                  name="description"
                  type="description"
                  id="description"
                  className="form-control"></textarea>
              </div>
            </div>
            <div className="col-sm-2">
              <div class="form-group">
                <label for="title">IMG (optional)</label>
                <input
                  required
                  value={img}
                  onChange={(e) => setImg(e.target.value)}
                  name="img"
                  type="img"
                  id="img"
                  className="form-control"
                />
              </div>
            </div>
          </div>

          <button
            onClick={handleSubmit}
            type="submit"
            className="btn btn-outline-primary btn-lg btn-block spacing">
            POST
          </button>
        </form>
      </div>
    </div>
  );
}

export default AppBody;
